import React from 'react';
import { inject, observer } from 'mobx-react';
import withAuth from '../../../HOC/withAuth';
import SettingBar from './SettingBar';
import PreviewResolutionPanel from '../../../components/PreviewResolutionPanel';

const Resolution = inject('userStore', 'snackbarStore', 'chargeStore')(observer(({ userStore, snackbarStore, chargeStore }) => {
  const capability = userStore.previewResolution;

  const save = value => userStore.saveDefaultPreviewResolution(value)
    .then(() => snackbarStore.showSnackbar('默认清晰度已保存'))
    .catch(error => {
      snackbarStore.showSnackbar('保存失败，请重试', 'error');
      throw error;
    });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <SettingBar />
      <PreviewResolutionPanel
        scope="global"
        value={capability?.defaultValue}
        capability={capability}
        onSave={save}
        onLocked={() => { snackbarStore.showSnackbar('升级到高级会员可使用超清', 'info'); chargeStore.openChargeDialog(); }}
      />
    </div>
  );
}));

export default withAuth(Resolution);
